export function formatCurrency(
  value: number,
  currencySymbol: string = 'R$'
): string {
  if (!value) return `${currencySymbol} 0,00`;

  return `${currencySymbol} ${(value / 100)
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+,)/g, '$1.')}`;
}

export const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};
